import script from "./NewsList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsList.vue?vue&type=script&setup=true&lang=js"

import "./NewsList.vue?vue&type=style&index=0&id=537db9fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-537db9fc"]])

export default __exports__